import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const EditHealthcareCourses = () => {
  return (
    <Edit
      title="Редактиране"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      transform={({ id, speciality, ...rest }) => rest}
    >
      <SimpleForm
        toolbar={<InactiveDeleteOptionEditToolbar />}
        defaultValues={record => ({
          ...record,
          healthcareSpeciality: record?.speciality,
        })}
      >
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditHealthcareCourses;
